import { useNuxtApp } from '#app'
import { Limits } from '@/types/other';


export function useProblem() {
  const { $api, $follow } = useNuxtApp()


  function availablePhotosToUpload(photos: string[]): number {
    if(!photos || photos.length < Limits.PhotosPerProblem){
      const activePhotos = photos ? photos.filter(photo => !photo.is_remove) : []
      return Limits.PhotosPerProblem - activePhotos.length
    }else{
      const activePhotos = photos.filter(photo => !photo.is_remove)
      return Math.max(0, Limits.PhotosPerProblem - activePhotos.length)
    }
  }



 
  return {
 
    availablePhotosToUpload
  }
}